import { render, staticRenderFns } from "./TransportPanel.vue?vue&type=template&id=38c08a0b&"
import script from "./TransportPanel.vue?vue&type=script&lang=js&"
export * from "./TransportPanel.vue?vue&type=script&lang=js&"
import style0 from "./TransportPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports